import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { Image } from '@xing-com/image';
import {
  spaceXXS,
  spaceS,
  spaceM,
  spaceL,
  scale180,
  xdlColorText,
  xdlColorBackgroundTertiary,
} from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

const SlideUpBanner = styled.div`
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.15);
  border: 2px solid ${xdlColorBackgroundTertiary};
  display: flex;
  width: 100%;
  background: ${xdlColorBackgroundTertiary};
  color: ${xdlColorText};
`;

const SlideUpContent = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: center;
  padding-bottom: ${spaceL};
  padding-top: ${spaceL};
  padding-left: ${spaceL};
`;

const Icon = styled(Image)`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  height: ${scale180};
  justify-content: center;
  width: ${scale180};
  margin-right: ${spaceL};
`;

const Close = styled(Button)`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  margin-left: ${spaceM};
  margin-top: ${spaceS};
  color: ${xdlColorText};
`;

const Text = styled(BodyCopy)`
  margin-bottom: 0;
  margin-top: ${spaceXXS};
  max-width: inherit;
  text-align: center;
`;

const ContentBox = styled.div`
  flex-direction: column;
  display: flex;
`;

export const Styled = {
  SlideUpContent,
  Icon,
  SlideUpBanner,
  Close,
  Text,
  ContentBox,
};
